import React from 'react';
import { Link } from 'react-router-dom';

const Note = () => {
    return (
        <div
            className="bg-blue-100 dark:bg-blue-900/30 border border-blue-200 dark:border-blue-800 text-blue-800 dark:text-blue-200 px-6 py-5 rounded-lg mb-8 flex items-start"
            role="alert"
        >
            <span className="material-symbols-outlined text-blue-600 dark:text-blue-400 mr-4">info</span>
            <div>
                <h4 className="font-bold mb-2">Note</h4>
                <ol className="list list-inside space-y-2">
                    <li>
                        You’re currently using the free version of WizeHelper, which provides quick insights through our lighter AI models and up to 3 potential leads per search - perfect for getting a taste of how we uncover quality leads on Reddit.
                    </li>
                    <li>
                        Want to unlock the full experience? Our premium version digs deeper, automatically scans subreddits, and sends you comprehensive lead lists straight to your inbox - daily, weekly, or monthly.{' '}
                        <Link to="/contact-us" className="font-semibold underline text-blue-800 dark:text-blue-200">
                            Contact us
                        </Link>{' '}
                        to learn more.
                    </li>
                </ol>
            </div>
        </div>
    );
};

export default Note;